import { NgClass, NgStyle } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

type OffsetPos = 'top' | 'left' | 'bottom' | 'right';
export interface SpinnerStyle {
    top?: string;
    left?: string;
    right?: string;
    bottom?: string;
    width?: string;
    height?: string;
}
@Component({
    selector: 'skl-spinner',
    templateUrl: './spinner.component.html',
    imports: [NgClass, NgStyle]
})
export class SpinnerComponent implements OnInit {
    // bindings
    @Input() public offset!: { top?: string, bottom?: string, left?: string, right?: string };
    @Input() public size: number = 10;
    @Input() public sizeUnit: string = 'px';
    @Input() public invert!: boolean;

    // other
    public spinnerStyle!: SpinnerStyle;
    public thinLine = false;

    public constructor() { }

    public ngOnInit(): void {

        const getStyleByKey = (key: OffsetPos, defaultValue: string | undefined): string | undefined => {
            return this.offset && this.offset[key] !== void 0
                ? this.offset[key]
                : defaultValue;
        };
        this.spinnerStyle = {
            top: getStyleByKey('top', `calc(50% - ${this.size / 2 + this.sizeUnit})`),
            left: getStyleByKey('left', `calc(50% - ${this.size / 2 + this.sizeUnit})`),
            bottom: getStyleByKey('bottom', undefined),
            right: getStyleByKey('right', undefined),
            width: this.size + this.sizeUnit,
            height: this.size + this.sizeUnit,
        };

        if (this.size <= 64) {
            this.thinLine = true;
        }
    }
}
